import { render, staticRenderFns } from "./black-vip-zone-section3.vue?vue&type=template&id=8e242876&scoped=true&"
import script from "./black-vip-zone-section3.vue?vue&type=script&lang=js&"
export * from "./black-vip-zone-section3.vue?vue&type=script&lang=js&"
import style0 from "./black-vip-zone-section3.vue?vue&type=style&index=0&id=8e242876&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e242876",
  null
  
)

export default component.exports